import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { imageBaseURL } from "../../../utils/fetchData";
import { JNTUK_PDF_Links } from "../../../utils/api.config";

const items = [
  {
    label: "About",
    children: [
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/about`,
        label: "About JNTUK",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/jntukvision`,
        label: "Governance, Leadership and Management",
        newTab: true,
        isSubdomain: true,
        children: [
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/jntukvision/institutional_vision_and_leadership`,
            label: "Institutional Vision and Leadership",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/jntukvision/core_values`,
            label: "Core Values",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/jntukvision/institutional_values_and_best_practices`,
            label: "Institutional Values and Best Practices",
            newTab: true,
            isSubdomain: true,
          },
        ],
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/SWOC`,
        label: "SWOC",
        newTab: true,
        isSubdomain: true,
        children: [
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/SWOC/institutional_strength`,
            label: "Institutional Strength",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/SWOC/institutional_weakness`,
            label: "Institutional Weakness",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/SWOC/institutional_opportunity`,
            label: "Institutional Opportunity",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/SWOC/institutional_challenge`,
            label: "Institutional Challenge",
            newTab: true,
            isSubdomain: true,
          },
        ],
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/SDD`,
        label: "Strategy Development and Development",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/institutional-bodies`,
        label: "Institutional Bodies",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${imageBaseURL}${JNTUK_PDF_Links.JNTU_Act_Link}`,
        label: "JNTU Act",
        newTab: true,
        pdfLink: true,
      },
      {
        to: `${imageBaseURL}${JNTUK_PDF_Links.RTI_Act_Link}`,
        label: "RTI Act",
        newTab: true,
        pdfLink: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/university-song`,
        label: "University Song",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/category/Press-Releases`,
        label: "Media/Press",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/jntuk-contacts`,
        label: "Contacts",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/gallery`,
        label: "Univ Gallery",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/convocations`,
        label: "Convocations",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/category/Tie-ups-and-Mou’s`,
        label: "Tie Ups & MOU's",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/governing-hierarchy`,
        label: "Governing Heirarchy",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/location-map`,
        label: "Location Map",
        newTab: true,
        isSubdomain: true,
      },
    ],
  },
  {
    label: "Administration",
    children: [
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/chancellor`,
        label: "Chancellor",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/vice-chancellor`,
        label: "Vice Chancellor",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/rector`,
        label: "Rector",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/registrar`,
        label: "Registrar",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/osd`,
        label: "OSD",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/executive-council`,
        label: "Executive Council",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/academic-senate`,
        label: "Academic Senate",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/board-of-studies`,
        label: "Board Of Studies",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/jntuk-vice-chancellor`,
        label: "JNTUK Vice Chancellor's",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/directorates`,
        label: "Directorates",
        newTab: true,
        isSubdomain: true,
        children: [
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/academics-and-planning-dap`,
            label: "Director, Academic Planning",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-academic-audit`,
            label: "Director, Academic Audit",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-of-evaluation-de`,
            label: "Director Of Evaluation",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/admissions-da`,
            label: "Director, Admissions",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-industry-institute-interaction-placements-and-training`,
            label: "Director, IIIP & Training",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-research-and-development`,
            label: "Director, Research And Development",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/faculty-development-centre`,
            label: "Director, Faculty Development Centre",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/infrastructure-development`,
            label: "Chief Engineer & Director, Infrastructure",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-foreign-university-relations-dfur`,
            label: "Director, Foreign University Relations",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/institute-of-science-and-technology-ist`,
            label: "Director, IST",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/school-of-management-studies`,
            label: "Director - School Of Management Studies",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-university-games-and-sports`,
            label: "Director(I/C) Director, University Games & Sports",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/internal-quality-assurance-cell`,
            label: "Director, IQAC University Legal Cell",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-empowerment-of-women-grievances`,
            label: "Director, Empowerment Of Women & Grievances",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-bics`,
            label: "Director, BICS",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-libraryn`,
            label: "Director, ODL & OL Programmes",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-green-campus-initiatives`,
            label: "Director, Green Campus Initiatives",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-incubation`,
            label: "Director(I/C) Incubation",
            newTab: true,
            isSubdomain: true,
          },
        ],
      },
      {
        to: "",
        label: "Principal's",
        newTab: false,
        children: [
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/principal-university-college-of-engineering-kakinada`,
            label: "Principal, UCEK",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/principal-university-college-of-engineering-narasaraopeta`,
            label: "Principal, UCEN",
            newTab: true,
            isSubdomain: true,
          },
        ],
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/special-officers`,
        label: "Special Officers",
        newTab: true,
        isSubdomain: true,
      },
    ],
  },
  {
    label: "Academics",
    children: [
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/methodology`,
        label: "Methodology",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/admissions`,
        label: "Admission",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/under-graduate`,
        label: "UG - Programmes Offered - Affiliated",
        newTab: true,
        isSubdomain: true,
        children: [
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/1`,
            label: "Bachelor of Technology",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/2`,
            label: "Bachelor of Pharmacy",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/3`,
            label: "Bachelor of Architecture",
            newTab: true,
            isSubdomain: true,
          },
        ],
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/post-graduate`,
        label: "PG - Programmers Offered - Affiliated",
        newTab: true,
        isSubdomain: true,
        children: [
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/4`,
            label: "Pharm D",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/5`,
            label: "Master of Technology",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/6`,
            label: "Master of Pharmacy",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/7`,
            label: "Master of Computer Applications",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/8`,
            label: "Master of Bussiness Administration",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/9`,
            label: "Management of Applied Management",
            newTab: true,
            isSubdomain: true,
          },
        ],
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/phd-courses`,
        label: "Research",
        newTab: true,
        isSubdomain: true,
        children: [
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/phd-courses/Promotion_of_Research_and_Facilities`,
            label: "Promotion of Research and Facilities",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/phd-courses/Innovations_and_Extension`,
            label: "Innovations and Extension",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/phd-courses/Innovation_Ecosystem`,
            label: "Innovation Ecosystem",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/phd-courses/Research_Branches`,
            label: "Branches",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/phd-courses/Regulations_and_Guidelines`,
            label: "Regulations & Guidelines",
            newTab: true,
            isSubdomain: true,
          },
        ],
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/category/Academic-Calendars`,
        label: "Academic Calendars",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/programmes-offered`,
        label: "Programmes Offered",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/academicsdata`,
        label: "Circular Aspects",
        newTab: true,
        isSubdomain: true,
        children: [
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/academicsdata/Circular_Aspects`,
            label: "Circular Aspects",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/academicsdata/Curriculum_Design_and_Development`,
            label: "Curriculum Design and Development",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/academicsdata/Curriculum_Enrichment`,
            label: "Curriculum Enrichment",
            newTab: true,
            isSubdomain: true,
          },
        ],
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/teachingLearnProcess`,
        label: "Teaching-Learning Process",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/studentsupportprogression`,
        label: "Student Support and Progression",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/infrastructurelearning`,
        label: "Infrastructure and Learning Resources",
        newTab: true,
        isSubdomain: true,
        children: [
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/infrastructurelearning/physical_facilities`,
            label: "Physical Facilities",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/infrastructurelearning/adequate_facilities`,
            label: "Adequate Facilities",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/infrastructurelearning/learning_resource`,
            label: "Learning Resource",
            newTab: true,
            isSubdomain: true,
          },
        ],
      },
      {
        to: "",
        label: "Constituent Colleges/Units",
        newTab: false,
        children: [
          {
            to: "https://www.jntucek.ac.in",
            label: "University College of Engineering Kakinada Campus",
            newTab: true,
            isExternal: true,
          },
          {
            to: "https://jntukucen.ac.in",
            label: "University College of Engineering Narasaraopet Campus",
            newTab: true,
            isExternal: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/sms`,
            label: "School of Management Studies",
            newTab: true,
            isSubdomain: true,
          },
        ],
      },
    ],
  },
  {
    label: "Campus School's",
    children: [
      {
        to: "",
        label: "INSTITUTE OF SCIENCE & TECHNOLOGY",
        newTab: false,
        children: [
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/shsr`,
            label: "School of Health Sciences and Research",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: "https://jntukfoodtech.com",
            label: "School of Food Technology",
            newTab: true,
            isExternal: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/sree`,
            label: "School of Renewable Energy & Environment",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: "https://jntukbiotech.com",
            label: "School of Biotechnology",
            newTab: true,
            isExternal: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/soa`,
            label: "School of Avionics",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/ssit`,
            label: "School of Spatial Information Technology",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/sopst`,
            label: "School of Pharmaceutical Sciences & Technologies",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/snt`,
            label: "School of Nano Technology",
            newTab: true,
            isSubdomain: true,
          },
        ],
      },
    ],
  },
  {
    label: "Examinations",
    children: [
      {
        to: "",
        label: "Examinations",
        newTab: false,
        children: [
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-of-evaluation-de`,
            label: "Director of Evaluation",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/controller-of-examination-ug`,
            label: "Controller of Examinations (UG)",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/controller-of-examinations-pg-sdc`,
            label: "Controller of Examinations (PG and SDC)",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/addl-controller-of-examinations`,
            label: "Addl. Controller of Examinations",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/category/Academic-Calendars`,
            label: "Academic Calendars",
            newTab: true,
            isSubdomain: true,
          },
        ],
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/university-examination-fee-structure-of-various-courses`,
        label: "UNIVERSITY EXAMINATION FEE STRUCTURE",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${imageBaseURL}${JNTUK_PDF_Links.JNTUK_MALPRACTICE_GUIDELINES}`,
        label: "JNTUK MALPRACTICE GUIDELINES",
        newTab: true,
        pdfLink: true,
      },
      {
        to: `${imageBaseURL}${JNTUK_PDF_Links.PHD_AWARDEES_LIST_2016_2019}`,
        label: "PH.D AWARDEES LIST 2016-2019",
        newTab: true,
        pdfLink: true,
      },
      {
        to: "https://jntukresults.edu.in/",
        label: "RESULTS PORTAL",
        newTab: true,
        isSubDomain: true,
      },
      {
        to: "",
        label: "AFFILIATED COLLEGES",
        newTab: false,
        children: [
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/affiliated-colleges-east-godavari`,
            label: "Affiliated Colleges – East Godavari",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/affiliated-colleges-west-godavari`,
            label: "Affiliated Colleges – West Godavari",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/affiliated-colleges-krishna`,
            label: "Affiliated Colleges – Krishna",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/affiliated-colleges-guntur`,
            label: "Affiliated Colleges – Guntur",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/affiliated-colleges-prakasam`,
            label: "Affiliated Colleges – Prakasam",
            newTab: true,
            isSubdomain: true,
          },
        ],
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/autonomous-colleges`,
        label: "LIST OF AUTONOMOUS COLLEGES",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: "",
        label: "DOWNLOADS",
        newTab: false,
        children: [
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/category/Academic-Syllabus`,
            label: "Syllabus",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${imageBaseURL}${JNTUK_PDF_Links["2F_of_UGC"]}`,
            label: "2F of UGC",
            newTab: true,
            pdfLink: true,
          },
          {
            to: `${imageBaseURL}${JNTUK_PDF_Links["12B_of_UGC"]}`,
            label: "12B of UGC",
            newTab: true,
            pdfLink: true,
          },
          {
            to: `${imageBaseURL}${JNTUK_PDF_Links.IT_Policies}`,
            label: "IT Policies",
            newTab: true,
            pdfLink: true,
          },
        ],
      },
    ],
  },
  {
    label: "Accreditations",
    children: [
      {
        to: "https://jntukiqac.com",
        label: "ABOUT NIRF",
        newTab: true,
        isExternal: true,
        children: [
          {
            to: "https://jntukiqac.com",
            label: "MINUTES & MEETING",
            newTab: true,
            isExternal: true,
          },
          {
            to: "https://jntukiqac.com",
            label: "COURSE-DETAILS",
            newTab: true,
            isExternal: true,
          },
          {
            to: "https://jntukiqac.com",
            label: "NAAC DATA FILES",
            newTab: true,
            isExternal: true,
          },
          {
            to: "https://jntukiqac.com",
            label: "PROGRAMME OFFERED",
            newTab: true,
            isExternal: true,
          },
        ],
      },
      {
        to: "",
        label: "FEEDBACK FORMS",
        children: [
          {
            to: "",
            label: "Alumini",
            newTab: false,
          },
          {
            to: "",
            label: "Faculty",
            newTab: false,
          },
          {
            to: "",
            label: "Industry",
            newTab: false,
          },
          {
            to: "",
            label: "Student",
            newTab: false,
          },
        ],
      },
      {
        to: "",
        label: "ACCREDITATIONS",
        children: [
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/naac-reports`,
            label: "NAAC Reports",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${imageBaseURL}${JNTUK_PDF_Links.JNTUK_NAAC_SSR_2023}`,
            label: "JNTUK NAAC SSR 2023",
            newTab: true,
            pdfLink: true,
          },
          {
            to: `${imageBaseURL}${JNTUK_PDF_Links.NIRF_Overall_Report_2023}`,
            label: "NIRF Overall Report -2023",
            newTab: true,
            pdfLink: true,
          },
          {
            to: `${imageBaseURL}${JNTUK_PDF_Links.JNTUK_AQAR_2017_18}`,
            label: "JNTUK AQAR 2017-18",
            newTab: true,
            pdfLink: true,
          },
          {
            to: `${imageBaseURL}${JNTUK_PDF_Links.NIRF_Overall_Report_2022}`,
            label: "NIRF Overall Report -2022",
            newTab: true,
            pdfLink: true,
          },
          {
            to: `${imageBaseURL}${JNTUK_PDF_Links.NAAC_Self_Study_Report_Feb_2017}`,
            label: "NAAC Self Study Report (SSR) - Feb 2017",
            newTab: true,
            pdfLink: true,
          },
          {
            to: `${imageBaseURL}${JNTUK_PDF_Links.Annual_Quality_Assurance_Reports}`,
            label: "Annual Quality Assurance Reports(AQAR)",
            newTab: true,
            pdfLink: true,
          },
          {
            to: `${imageBaseURL}${JNTUK_PDF_Links.ARAQ_Of_Student_Satisfaction_Survey}`,
            label:
              " Analysis Report and Questionnaire of Student Satisfaction Survey",
            newTab: true,
            pdfLink: true,
          },
          {
            to: `${imageBaseURL}${JNTUK_PDF_Links.National_Institutional_Rankings_Framework_2020}`,
            label: "National Institutional Rankings Framework (NIRF) – 2020",
            newTab: true,
            pdfLink: true,
          },
        ],
      },
    ],
  },
  {
    label: "Information For...",
    children: [
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/campus-buildings`,
        label: "Campus Building",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/convocations`,
        label: "Convocations",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/category/Latest-Events`,
        label: "Latest Events",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: `${process.env.REACT_APP_JNTUK_BASE_URL}/jntuk-contacts`,
        label: "Contacts",
        newTab: true,
        isSubdomain: true,
      },
      {
        to: "https://infyspringboard.onwingspan.com/web/en/page/lex_auth_0136054520526520321",
        label: "Infosys Springboard",
        newTab: true,
        isExternal: true,
      },
      {
        to: "https://lms.jntuk.org",
        label: "Learning Management System",
        newTab: true,
        isExternal: true,
      },
      {
        to: "https://odl.jntuk.org",
        label: "Open Distance Learning /Online Learning",
        newTab: true,
        isExternal: true,
      },
      {
        to: "https://bcde.online",
        label: "Board for Community Development through Education (BCDE)",
        newTab: true,
        isExternal: true,
      },
      {
        to: "",
        label: "JNTUK UNITS",
        children: [
          {
            to: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/sc-st-cell`,
            label: "SC & ST Cell",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: "http://arc.jntuk.edu.in",
            label: "Anti Ragging Cell",
            newTab: true,
            isSubdomain: true,
          },
          {
            to: `${imageBaseURL}${JNTUK_PDF_Links.Sexual_Harassment_Committees}`,
            label: "Sexual Harassment Committees",
            newTab: true,
            pdfLink: true,
          },
          {
            to: "https://jntuknss.org",
            label: "NSS Cell",
            newTab: true,
            isExternal: true,
          },
          {
            to: "https://jntukiqac.com",
            label: "IQAC",
            newTab: true,
            isExternal: true,
          },
          {
            to: "https://ecosak.org.in",
            label: "Alumni Engagement",
            newTab: true,
            isExternal: true,
          },
          {
            to: "",
            label: "IIIP & SKILL DEVELOPMENT",
            children: [
              {
                to: `${imageBaseURL}${JNTUK_PDF_Links.Placements_Graph}`,
                label: "Placements Graph",
                newTab: true,
                pdfLink: true,
              },
              {
                to: `${imageBaseURL}${JNTUK_PDF_Links.Visits_to_Industry}`,
                label: "Visits to Industry's",
                newTab: true,
                pdfLink: true,
              },
              {
                to: `${imageBaseURL}${JNTUK_PDF_Links.Lab_Openings}`,
                label: "Lab Openings",
                newTab: true,
                pdfLink: true,
              },
              {
                to: `${imageBaseURL}${JNTUK_PDF_Links.Skill_Development_Programmes}`,
                label: "Skill Development Programmes",
                newTab: true,
                pdfLink: true,
              },
            ],
          },
        ],
      },
    ],
  },
];
function Accordion() {
  const renderNestedLevels = (data) => {
    return data.map((item, itemIndex) => (
      <SubLevelComp
        item={item}
        renderNestedLevels={renderNestedLevels}
        key={itemIndex}
      />
    ));
  };

  return renderNestedLevels(items);
}

const SubLevelComp = ({ item, renderNestedLevels }) => {
  const location = useLocation();
  const [selected, setselected] = React.useState("");

  const toggle = () => {
    setselected(selected === "" ? "active" : "");
  };

  const hasChidlren = (item) => {
    return Array.isArray(item.children) && item.children.length > 0;
  };

  const externalLink = (url) => {
    const userConfirmed = window.confirm(
      "You are being redirected to an external website. Please note that JNTUK Portal is not responsible for external websites content & privacy policies."
    );

    if (userConfirmed) {
      window.open(url, "_blank");
    } else {
    }
  };
  const subDomain = (url) => {
    // const userConfirmed = window.confirm(
    //   "You are being redirected to an internal sub-domain website. The sub-domain website will open in a New Tab"
    // );

    // if (userConfirmed) {
    window.open(url, "_blank");
    // } else {
    // }
  };

  return (
    <li
      className={
        selected === "active"
          ? "menu-item-has-children current-menu-item"
          : "menu-item-has-children"
      }
    >
      <div className="d-flex">
        {item.newTab && item.isSubdomain ? (
          <a onClick={() => subDomain(item.to)}>{item.label}</a>
        ) : item.newTab && item.isExternal ? (
          <a onClick={() => externalLink(item.to)}>{item.label}</a>
        ) : item.newTab && item.pdfLink ? (
          <a href={item.to} target="_blank">
            {item.label}
          </a>
        ) : (
          <Link
            to={item.to}
            className={location.pathname === item.to ? "active-menu" : ""}
          >
            {item.label}
          </Link>
        )}
        {hasChidlren(item) && <span onClick={() => toggle()}></span>}
      </div>
      {selected && (
        <ul
          className={
            selected === "active" ? "sub-menu current-menu" : "sub-menu"
          }
        >
          {hasChidlren(item) && renderNestedLevels(item.children)}
        </ul>
      )}
    </li>
  );
};

const RSMobileMenu = ({
  setMenuOpen,
  menuOpen,
  parentMenu,
  secondParentMenu,
  headerFullWidth,
}) => {
  const location = useLocation();

  return (
    <div
      className={
        headerFullWidth ? "container-fluid relative" : "container relative"
      }
    >
      <div className={menuOpen ? "mobile-menu-part open" : "mobile-menu-part"}>
        <div className="mobile-menu">
          <ul className="nav-menu">
            <Accordion />
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RSMobileMenu;
